import React from "react";
import PropTypes from "prop-types";
import styles from "./EditButton.module.css";
import EditBtn from "./Image/EditBtn.png";

const EditButton = ({ onClick }) => {
  const handleButtonClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      type="Edit Button"
      className={styles.editbtn}
      onClick={handleButtonClick}
    >
      <img src={EditBtn} alt="EditBtn" text="Edit" />
    </div>
  );
};

EditButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default EditButton;
